import React from "react";
import Loader from 'react-loader-spinner'
import Modal from "../components/Modal";
import { translate } from "../utils/useful";


class RemoveModal extends React.Component {
  state = {
    isLoadingRemove: false,
    id: null,
    index: null
  }

  showModal = (id, index) => {
    this.setState({ id, index })
    this.removeModal.showModal()
  }

  // hideModal = () => {
  //   this.removeModal.hideModal()
  // }


  render() {
    return (
      <Modal cancelModal={this.props.cancelModal} ref={el => this.modal = el} maxWidth={350} className="flexcc text-center">
          <div className="w-100 h-100 p-4" style={{ backgroundColor: '#fff', borderRadius: 8 }}>
          <div className="flexcc flex-column">

            <img src={'/images/remove.png'} alt="" width="60px"/>

            <p className="mt-3 text-small">{translate("Are you sure you want to remove?")}</p>
          </div>


          {!this.props.isLoading && (
            <div className="flexcc mt-2">
              <button className="m-1 p-3 px-4 white text-bold text-uppercase" onClick={() => { this.props.removeFunction(this.state.id, this.state.index) }} style={{ backgroundColor: '#ee5050',  borderRadius: 6, }}>
                <p style={{ margin: 0, padding: 0, lineHeight: 1, textAlign: 'center' }}>{translate('remove')}</p>
              </button>
              <button className="m-1 p-3 px-4 white text-bold text-uppercase" onClick={() => this.modal.hideModal()} style={{ borderRadius: 6,  backgroundColor: '#789',  }}>
                <p style={{ margin: 0, padding: 0, lineHeight: 1, textAlign: 'center' }}>{translate("cancel")}</p>
              </button>
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            {this.props.isLoading && (
              <Loader
                type="Puff"
                color="rgba(0,122,255,1)"
                height="40"
                width="40"
              />)}
          </div>
        </div>

      </Modal >
    );
  }
}



export default RemoveModal;
